export const CCPA_ANALYTICS = 'floracal_ccpa_analytics';
export const CCPA_MARKETING = 'floracal_ccpa_marketing';
export const CCPA_PERSONALIZATION = 'floracal_ccpa_personalization';
export const ACCESSIBILITY = 'floracal_accessibility';
